import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useBids } from '@/hooks/useAuctions';
import { formatMoney, formatRelativeTime } from '@/lib/format';
import { Skeleton } from '@/components/ui/Skeleton';
import { haptic } from '@/lib/telegram';
import clsx from 'clsx';
import styles from './BidsList.module.css';

interface Props {
  auctionId: string;
  currentLeaderId: string | null;
}

export const BidsList = ({ auctionId, currentLeaderId }: Props) => {
  const { data: bids, isLoading } = useBids(auctionId);
  const [expanded, setExpanded] = useState(false);

  if (isLoading) {
    return (
      <div className={styles.list}>
        {Array.from({ length: 3 }).map((_, i) => (
          <Skeleton key={i} height={48} />
        ))}
      </div>
    );
  }

  if (!bids || bids.length === 0) {
    return (
      <div className={styles.empty}>
        <p>Ставок ещё нет. Будь первым.</p>
      </div>
    );
  }

  const visible = expanded ? bids : bids.slice(0, 5);
  const hasMore = bids.length > 5;

  return (
    <>
      <div className={styles.list}>
        {visible.map((bid, idx) => {
          const isLeader = bid.bidder.id === currentLeaderId && idx === 0;
          return (
            <Link
              key={bid.id}
              to={`/user/${bid.bidder.id}`}
              onClick={() => haptic.light()}
              className={clsx(styles.row, isLeader && styles.rowLeader)}
            >
              {bid.bidder.avatar_url ? (
                <img
                  src={bid.bidder.avatar_url}
                  alt=""
                  className={styles.avatar}
                />
              ) : (
                <div className={styles.avatarFallback}>
                  {bid.bidder.display_name.charAt(0)}
                </div>
              )}

              <div className={styles.main}>
                <p className={styles.name}>
                  {bid.bidder.display_name}
                  {bid.bid_type === 'auto' && (
                    <span className={styles.autoTag}>AUTO</span>
                  )}
                  {isLeader && <span className={styles.leaderTag}>лидер</span>}
                </p>
                <p className={styles.time}>{formatRelativeTime(bid.created_at)}</p>
              </div>

              <p className={clsx(styles.amount, isLeader && styles.amountLeader)}>
                {formatMoney(bid.amount)}
              </p>
            </Link>
          );
        })}
      </div>

      {hasMore && (
        <button
          className={styles.expandBtn}
          onClick={() => setExpanded((v) => !v)}
        >
          {expanded ? 'Свернуть' : `Показать ещё ${bids.length - 5}`}
        </button>
      )}
    </>
  );
};